module.exports = "<div style={{ maxWidth: 300 }}>\n  <FileAttachment\n    fileType=\"powerpoint\"\n    fileName=\"design-system-example.ppt\"\n  />\n</div>;\n"